module.exports = __webpack_public_path__ + "img/encarnacao.1f010f3d.jpg";